import moment from "moment-jalaali";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { searchUser, searchUserInit } from "../../../../redux/actions/search-user";
import { createBooking } from "../../../../redux/actions/create-booking";
import { State } from "../../../../redux/reducers/root";
import { useQuery } from "../../../../utils/hooks";
import { getTimeslotStatus } from "../../../../utils/timeslots";
import Button from "../../button";
import Input from "../../form/input";
import Textarea from "../../form/textarea";
import ReactSelect from "../../react-select";
import ModalTemplate from "../template";
import { hideModal, setModal } from "../../../../redux/actions/modals";
import BookingItem from "./booking-item";
import { fetchBookings, setBookingCanceled } from "../../../../redux/actions/bookings";
import { setTimeslotBlocked } from "../../../../redux/actions/timeslots";
import { ModalPayload } from "../../../../redux/models/modals";
import Dialog from "../../dialog/dialog";
import CancelDialog from "./cancel-dialog";
import { FieldError } from "react-hook-form";
import { REGISTER_UER_MODAL } from "../constants";

interface Props {}

const TimeslotDetailModal: React.FC<Props> = () => {
  const modals = useSelector((state: State) => state.modals) as ModalPayload;

  const [isAssigning, setIsAssigning] = modals.data?.tel ? useState<boolean>(true) : useState<boolean>(false); // if in the middle of assigning
  const [tel, setTel] = modals.data?.tel ? useState(modals.data?.tel) : useState("");
  const [selectedPractice, setSelectedPractice] = useState<string | number>();
  const [notes, setNotes] = useState("");
  // const [isCanceling, setIsCanceling] = useState<boolean>(false);
  const [isSubmittin, setIsSubmittin] = useState<boolean>(false); // if the request is being sent
  const [bookingOfTimeslot, setBookingOfTimeslot] = useState<any>({});
  const searchUserState = useSelector((state: State) => state.searchUser);
  const practices = useSelector((state: State) => state.practices);
  const officeId = useQuery().get("office")!;
  const doctorId = modals.data.doctorId;

  const practiceData = practices.data[parseInt(officeId)];
  const practicesOption = practiceData?.data?.map(({ practice }) => ({ value: practice.id, label: practice.name }));

  const dispatch = useDispatch();

  const timeslot = modals.data?.timeslot;

  const getBookingOfTimeslot = async () => {
    const result = (await dispatch(fetchBookings(Number(doctorId), { timeslot: timeslot.id }))) as any;
    Object.keys(result.payload?.data).length > 0 && setBookingOfTimeslot(result.payload?.data[0]);
  };

  useEffect(() => {
    getBookingOfTimeslot();
  }, [timeslot]);

  const booked = timeslot?.booked;
  const blocked = timeslot?.blocked;
  const m = moment.unix(parseInt(timeslot?.dateTime));
  const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (tel) {
      dispatch(searchUser(tel));
    }
  }, []);

  const close = () => {
    dispatch(hideModal());
  };

  const assign = async () => {
    setError("");
    if (isAssigning) {
      if (searchUserState.status === "OK") {
        if (!selectedPractice) {
          setError("لطفا نوع تخصص را انتخاب کنید");
        } else {
          setIsSubmittin(true);
          await dispatch(createBooking(searchUserState?.data?.id!, selectedPractice!, timeslot?.id, notes, officeId));
          dispatch(searchUserInit());
          setIsAssigning(false);
          setIsSubmittin(false);
          close();
        }
      } else {
        setIsSubmittin(true);
        try {
          if (tel.length < 11) {
            setError("این فیلد باید حداقل 11 رقم باشد");
          } else {
            await dispatch(searchUser(tel));
          }
        } catch (e) {
          dispatch(setModal({ modal: REGISTER_UER_MODAL, data: { tel, timeslot, type: "booking" }, visible: true }));
        }

        setIsSubmittin(false);
      }
    } else {
      setIsAssigning(true);
    }
  };

  const abortAssign = () => {
    dispatch(searchUserInit());
    setIsAssigning(false);
  };

  const cancel = async (cancelDescription: string) => {
    if (bookingOfTimeslot) await dispatch(setBookingCanceled(bookingOfTimeslot.id, cancelDescription, officeId));
    setShowDeleteDialog(false);
    close();
  };

  const block = async (value: boolean) => {
    await dispatch(setTimeslotBlocked(timeslot?.id, value, officeId));
    close();
  };
  return (
    <ModalTemplate
      title="جزئیات"
      icon="fa fa-calendar-alt"
      className={"text-pkc-primary"}
      leftTitle={`شناسه ${timeslot.id}`}
    >
      <Dialog
        className="overflow-hidden rounded-3xl"
        show={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
      >
        <CancelDialog
          close={() => setShowDeleteDialog(false)}
          onSubmit={async (d) => await cancel(d.cancelDescription)}
        />
      </Dialog>
      <hr className="my-3" />
      <div className="mb-3">{m.format("dddd jYYYY/jMM/jDD")}</div>
      <div className="flex mb-3">
        <div className="flex-1">{`ساعت ${m.format("HH:mm")}`}</div>
        <div className="flex-1">
          <span>وضعیت: </span>
          <span className={blocked ? "text-pkc-red" : "text-pkc-primary"}>{getTimeslotStatus(timeslot)}</span>
        </div>
      </div>
      <hr className="mb-3" />
      {booked && Object.keys(bookingOfTimeslot).length > 0 && <BookingItem booking={bookingOfTimeslot} />}

      {isAssigning &&
        (searchUserState.status !== "OK" ? (
          <>
            <div>
              شماره همراه مراجعه کننده رو وارد نمایید
              <Input
                maxLength={11}
                value={tel}
                error={error ? ({ message: error } as FieldError) : undefined}
                onChange={async (e) => {
                  setError("");
                  setTel(e.target.value);
                }}
                name="tel"
                label=""
              />
            </div>
          </>
        ) : (
          <div>
            <div className="mb-3">
              <span>رزرو وقت برای </span>
              <span>{searchUserState.data.name}</span>
            </div>
            <ReactSelect
              options={practicesOption || []}
              value={selectedPractice}
              onChange={(v: any) => {
                setError("");
                setSelectedPractice(v);
              }}
              menuPlacement="auto"
            />
            {error && <div className="text-pkc-red">{error}</div>}
            <Textarea
              className="mt-2"
              containerClassName="mt-2"
              value={notes}
              onChange={(e) => setNotes(e.currentTarget.value)}
              label="یادداشت"
              placeholder="متن توضیحات خود را وارد نمایید"
            />
          </div>
        ))}
      <div className="grid grid-cols-2 grid-rows-1 gap-x-2">
        {!blocked && !booked && (
          <>
            {isAssigning ? (
              <Button
                onClick={abortAssign}
                className="flex-1 !text-pkc-form-icon !border-pkc-form-icon"
                variant="outline"
              >
                انصراف
              </Button>
            ) : (
              <Button onClick={() => block(true)} className="flex-1 !text-pkc-red !border-pkc-red" variant="outline">
                غیرفعال کردن(بستن)
              </Button>
            )}
            <Button onClick={assign} className="flex-1" variant="contained" loading={isSubmittin}>
              اختصاص وقت
            </Button>
          </>
        )}
        {(booked || blocked) && (
          <Button onClick={close} className="flex-1 !text-pkc-form-icon !border-pkc-form-icon" variant="outline">
            بستن جزئیات
          </Button>
        )}
        {blocked && (
          <Button onClick={() => block(false)} className="flex-1  !border-pkc-form-icon" variant="contained">
            فعال کردن
          </Button>
        )}
        {booked && (
          <Button
            onClick={() => setShowDeleteDialog(true)}
            className="flex-1 !text-pkc-red !border-pkc-red"
            variant="outline"
          >
            لغو رزرو
          </Button>
        )}
      </div>
    </ModalTemplate>
  );
};

export default TimeslotDetailModal;
